module.exports = __webpack_public_path__ + "img/bell-alt-ring-p.46f61c6e.svg";